import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private readonly router: Router, private readonly authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Check if the user is authenticated
    const isAuthenticated = this.authService.isAuthenticated();

    if (isAuthenticated) {
      // User is authenticated, allow access to the route
      return true;
    } else {
      // User is not authenticated: stop redirecting to `/login` (route may be removed).
      // Use a public page instead.
      this.authService.redirectUrl = state.url;

      return this.router.parseUrl('/home');
    }
  }
}
